import cn from 'classnames';

import classes from './Text.module.scss';
import { TextProps } from './Text.props';

export const Text = ({
  size = 'l',
  bold,
  semibold,
  regular,
  medium,
  className,
  children,
  ...props
}: TextProps): JSX.Element => {

  const sizeClass = size === 'm' && classes[size];

  return (
    <p
      {...props}
      className={cn(className, sizeClass, {
        [classes.bold]: bold,
        [classes.semibold]: semibold,
        [classes.regular]: regular,
        [classes.medium]: medium,
      })}
    >
      {children}
    </p>
  );
};
